import Library from "@/classes/Library"
import LibraryCost from "@/classes/LibraryCost"
import Pagination from "@/classes/Pagination"
import SubscriptionLibrary from "@/classes/SubscriptionLibrary"
import { LibraryType } from "@/classes/enums/LibraryType"
import SubscriptionLibraryUpsertRequest from "@/classes/request_objects/libraries/SubscriptionLibraryUpsertRequest"
import UpdatePremiumLibraryRequest from "@/classes/request_objects/libraries/UpdatePremiumLibraryRequest"
import { LibraryService } from "@/classes/services/LibraryService"
import { AxiosError } from "axios"
import moment from "moment"

const libraryService = new LibraryService()

const state = {
  libraries: [] as Library[],
  subscriptionLibraries: [] as SubscriptionLibrary[],
  pagination: new Pagination(1, 5),
  totalLibraryCount: 0,
  totalSubscriptionLibraryCount: 0,
  query: '',
  librariesToUpdate: [],
  subscriptionLibrariesToUpdate: [] as SubscriptionLibrary[],
  organizationId: ''
}

const getters = {
  getOrganizationId: () => {
    return state.organizationId
  },
  getLibraries: () => {
    return state.libraries
  },
  getSubscriptionLibraries: () => {
    return state.subscriptionLibraries
  },
  getLibrariesToUpdate: () => {
    return state.librariesToUpdate
  },
  getSubscriptionLibrariesToUpdate: () => {
    return state.subscriptionLibrariesToUpdate
  },
  getPagination: () => {
    return state.pagination
  },
  getQuery: () => {
    return state.query
  },
  getTotalLibraryCount: () => {
    return state.totalLibraryCount
  },
  getTotalSubscriptionLibraryCount: () => {
    return state.totalSubscriptionLibraryCount
  },
}

const mutations = {
  setOrganizationId(state, payload) {
    state.organizationId = payload
  },
  setPagination(state, payload) {
    state.pagination.page = payload.page
    state.pagination.itemsPerPage = payload.itemsPerPage
    state.pagination.sortBy = payload.sortBy
    state.pagination.sortDesc = payload.sortDesc
  },
  setQuery(state, payload) {
    state.query = payload
  },
  setLibraries(state, payload) {
    state.libraries = payload
  },
  setSubscriptionLibraries(state, payload) {
    state.subscriptionLibraries = payload
  },
  setLibrariesToUpdate(state, payload) {
    state.librariesToUpdate = payload
  },
  setSubscriptionLibrariesToUpdate(state, payload) {
    state.subscriptionLibrariesToUpdate = payload
  },
  resetQueryValues(state, payload) {
    state.organizationId = payload
    state.librariesToUpdate = []
    state.pagination = new Pagination(1, 5)
    state.query = ''
    state.libraries = []
    state.subscriptionLibraries = []
  }
}

const actions = {
  // async searchLibrariesAsync({ state }) {
  //   libraryService
  //     .getAll({
  //       params: {
  //         organizationId: state.organizationId,
  //         page: state.pagination.page,
  //         pageSize: state.pagination.itemsPerPage,
  //         sortBy: state.pagination.sortBy[0],
  //         sortDesc: state.pagination.sortDesc[0],
  //         query: state.query,
  //       },
  //     })
  //     .then((response1: any) => {

  //       libraryService.getCost({
  //         params: {}
  //       }, response1.data.items.map(l => l.id)).then((response2: any) => {
  //         let costs = response2.data as LibraryCost[]
  //         let libraries = response1.data.items as Library[]
  //         for (const library of libraries) {
  //           library.cost = costs.find(r => r.libraryId === library.id) ?? new LibraryCost()
  //           library.cost.isPaidLibrary = library.type === LibraryType.Purchased
  //           library.cost.libraryId = library.id
  //         }

  //         state.libraries = libraries
  //         state.totalLibraryCount = response1.data.totalItems
  //       })
  //     })
  // },

  async searchSubscriptionLibrariesAsync({ state }, organizationId) {
    libraryService
      .getSubscriptionLibraries({
        params: {
          purchasedByOrgId: organizationId,
          page: state.pagination.page,
          pageSize: state.pagination.itemsPerPage,
          query: state.query,
        },
      })
      .then((response: any) => {
          state.subscriptionLibraries = response.data.items as SubscriptionLibrary[]
          state.totalSubscriptionLibraryCount = response.data.totalItems
          for(const lib of state.subscriptionLibraries) {
            if(lib.expirationDate) {
              lib.expirationDate = moment(lib.expirationDate).format('YYYY-MM-DD')
            }
          }
      })
  },

  // async updateLibrariesAsync({ state }, payload) {
  //   const requestObjects = payload.map((datum: Library) => {
  //     const type = datum.cost.isPaidLibrary ? LibraryType.Purchased : datum.type
  //     const requestObject = new UpdatePremiumLibraryRequest(datum.id, type, datum.cost.startRange, datum.cost.endRange, datum.cost.price)
  //     return requestObject
  //   })

  //   libraryService.updatePublicPurchaseStatus({
  //     params: {
  //       libraries: requestObjects
  //     }
  //   })
  // },

  async updateLibrarySubscriptionsAsync({ state, dispatch }, organizationId) {
    dispatch('organizations/clearAlertAsync', null, { root: true })
    const errors = [] as AxiosError[]

    for(const lib of state.subscriptionLibrariesToUpdate) {
      const request = new SubscriptionLibraryUpsertRequest(organizationId, lib.id, lib.totalSeats, lib.isSubscribed, lib.expirationDate)
      libraryService.updateLibrarySubscriptions(request)
      .then(() => {
        dispatch('organizations/setSuccessAlertAsync', `Library subscriptions updated`, { root: true })
      })
      .catch((error: AxiosError<Error>) => {
        errors.push(error)
      })
    }
    
    if(errors.length > 0) {
      dispatch('organizations/clearAlertAsync', null, { root: true })
      dispatch('organizations/setErrorAlertAsync', errors[0], { root: true })
    }


  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
